var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Users'),(_vm.showCounterpartyTable)?_c('Users',{attrs:{"association":"Counterparty","association-title":"Counterparties","association-title-singular":"Counter Party"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }